import { Minus, Plus } from 'lucide-react';
import React from 'react';

import { TOOLBAR_ICON_SIZE, toolbarControlLabelStyle, toolbarReadoutStyle } from './toolbar-styles';
import { ToolbarButton } from './toolbar-button';

export type ToolbarStepperProps = {
	title: string;
	value: number;
	min: number;
	max: number;
	step: number;
	onChange: (value: number) => void;
	/** Decimal places for the readout; the value written back is rounded to the same precision */
	precision?: number;
	/** Caption drawn before the control -- without it the readout is a bare number that names nothing */
	label?: string;
	/** Overrides the readout text, e.g. rendering a 0-1 opacity as a percentage */
	format?: (value: number) => string;
};

/** One click, one commit -- a stepper never needs preview state, unlike the colour controls */
export const ToolbarStepper = (props: ToolbarStepperProps): React.ReactElement => {
	const { title, value, min, max, step, onChange, precision = 2, label, format } = props;
	const round = (next: number): number => Number(next.toFixed(precision));
	const readout = format ? format(round(value)) : `${round(value)}`;

	return (
		<span style={{ display: 'inline-flex', alignItems: 'center', gap: '2px' }}>
			{label ? <span style={toolbarControlLabelStyle}>{label}</span> : null}
			<ToolbarButton title={`Decrease ${title}`} disabled={value <= min} onClick={() => onChange(round(Math.max(min, value - step)))}>
				<Minus size={TOOLBAR_ICON_SIZE - 2} />
			</ToolbarButton>
			<span style={toolbarReadoutStyle} title={title}>{readout}</span>
			<ToolbarButton title={`Increase ${title}`} disabled={value >= max} onClick={() => onChange(round(Math.min(max, value + step)))}>
				<Plus size={TOOLBAR_ICON_SIZE - 2} />
			</ToolbarButton>
		</span>
	);
};
